"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerInfosResponseT = exports.ServerInfosResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Holds the Server information, this is a basic table holding various information about the currently running server
 * like its local ip address (useful for standalone users so they can specify the ip of the server more easily) and any more
 * infos we might want to add in the future. (like java version, working dir, server version ....)
 * This only holds the local ip for now. But there will be other information added as we chose to display them on the gui for instance
 */
class ServerInfosResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsServerInfosResponse(bb, obj) {
        return (obj || new ServerInfosResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsServerInfosResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ServerInfosResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    localIp(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startServerInfosResponse(builder) {
        builder.startObject(1);
    }
    static addLocalIp(builder, localIpOffset) {
        builder.addFieldOffset(0, localIpOffset, 0);
    }
    static endServerInfosResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createServerInfosResponse(builder, localIpOffset) {
        ServerInfosResponse.startServerInfosResponse(builder);
        ServerInfosResponse.addLocalIp(builder, localIpOffset);
        return ServerInfosResponse.endServerInfosResponse(builder);
    }
    unpack() {
        return new ServerInfosResponseT(this.localIp());
    }
    unpackTo(_o) {
        _o.localIp = this.localIp();
    }
}
exports.ServerInfosResponse = ServerInfosResponse;
class ServerInfosResponseT {
    constructor(localIp = null) {
        this.localIp = localIp;
    }
    pack(builder) {
        const localIp = (this.localIp !== null ? builder.createString(this.localIp) : 0);
        return ServerInfosResponse.createServerInfosResponse(builder, localIp);
    }
}
exports.ServerInfosResponseT = ServerInfosResponseT;
